export enum KeyEventType {
    KeyPress = "keypress",
    KeyDown = "keydown",
    KeyUp = "keyup"
}
